export const DEMO_WORKSPACE_OPERATOR_EMAIL = "demo@snowsproam.com";

export const isDemoWorkspaceOperatorEmail = (email = "") => (
  String(email).trim().toLowerCase() === DEMO_WORKSPACE_OPERATOR_EMAIL
);

export const demoAssignmentTargetLabel = (target = {}) => {
  const name = String(target?.name || "").trim();
  const username = String(target?.username || "").trim();
  if (name && username) return `${name} (@${username})`;
  if (username) return `@${username}`;
  return String(target?.email || "Customer account");
};
